import { type HTMLAttributes, type ReactNode, forwardRef } from "react";

import { Tag } from "@snapchat/snap-design-system";

import { LensRowBadgeWrapper } from "./LensRowBadge.styles";

interface LensRowBadgeProps extends Omit<HTMLAttributes<HTMLDivElement>, "className"> {
    children: ReactNode;
    className?: string;
    dataTestId?: string;
}

// Forwards the ref and remaining props so the badge can be a Tooltip trigger.
export const LensRowBadge = forwardRef<HTMLDivElement, LensRowBadgeProps>(
    ({ children, className, dataTestId, ...wrapperProps }, ref) => (
        <LensRowBadgeWrapper {...wrapperProps} ref={ref} data-testid={dataTestId}>
            <Tag size="small" className={className}>
                {children}
            </Tag>
        </LensRowBadgeWrapper>
    ),
);
LensRowBadge.displayName = "LensRowBadge";
